// Used in assignment-info-dialog.component.html and tiles.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "custom-activity-directions",
    templateUrl: "./custom-activity-directions.component.html",
    styleUrls: [
        "./custom-activity-directions.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class CustomActivityDirectionsComponent implements OnInit {
    @Input() directions: string;
    @Input() fontSize: string;

    constructor() {}

    ngOnInit(): void {}
}
